import { useQuery } from "@tanstack/react-query";
import { fetchUsers } from "../services/userService";

export const useUsers = (page = 1, search = "", status = "") => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["users", page, search, status],
    queryFn: () => fetchUsers(page, search, status),
    select: (response) => {
      return {
        users: response.message?.users?.data || [],
        userStats: response.message || {},
        pagination: {
          current_page: response.message?.users?.current_page,
          total: response.message?.users?.total,
          per_page: response.message?.users?.per_page,
          last_page: response.message?.users?.last_page,
        },
      };
    },
  });

  return {
    users: data?.users || [],
    loading: isLoading,
    error: error?.message || null,
    userStats: data?.userStats || {},
    pagination: data?.pagination || null,
  };
};
